/**
 * Selectors for the Branding integration
 */
import useBrandingCache from '@integrations/partners/branding/useBrandingQuery.cache';
import { useGetPartnerImage } from '@integrations/partners/partners.utils';
import { PartnerBaseAttributes } from '@integrations/partners/partners.types';

/**
 * Get partner logo from cobrandedogo - we see this selector in standard header and sku pricing component
 * @returns {string | undefined}
 */
export const useBrandingLogo = () => {
  const partner = useBrandingCache() as PartnerBaseAttributes;
  const { logo } = useGetPartnerImage(partner);
  return logo;
};
